import * as actionTypes from '../actions/actionTypes';

const initialState = {
    ticket: {
        id: '',
        status: 1,
        device: '',
        isp: '',
        description: '',
        type: 0,
        created: null,
        modified: null
    },
    id: null,
    loading: null,
    error: null
};

const reducer = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.SET_CURRENT_TICKET:
            return {
                ...state,
                loading: null,
                error: null,
                ticket: {...state,
                    id: '',
                    status: 1,
                    device: '',
                    isp: '',
                    description: '',
                    type: 0,
                    created: null,
                    modified: null
                },
                id: action.payload
            };
        case actionTypes.GET_TICKET_INITIALIZE:
            return {
                ...state,
                loading: null,
                error: null,
                ticket: {...state, 
                    id: '',
                    status: 1,
                    device: '',
                    isp: '',
                    description: '',
                    type: 0,
                    created: null,
                    modified: null
                },
                id: null
            };
        case actionTypes.GET_TICKET_LOADING:
            return {
                ...state,
                loading: true,
                error: null,
                ticket: {...state, 
                    id: '',
                    status: 1,
                    device: '',
                    isp: '',
                    description: '',
                    type: 0,
                    created: null,
                    modified: null
                }
            };
        case actionTypes.GET_TICKET_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                ticket: {...state, 
                    id: '',
                    status: 1,
                    device: '',
                    isp: '',
                    description: '',
                    type: 0,
                    created: null,
                    modified: null
                }
            };
        case actionTypes.GET_TICKET_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                ticket: action.payload
            };
        default:
            return state;
    }
};

export default reducer;